import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeLeasedBuildingIdentifier(): StaticSharedField {
  return {
    type: FIELD_TYPE_TXT,
    label: 'Building identifier',
    propName: 'building_identifier',
    element: 'building_identifier',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOBUILDINGIDENTIFIER',
        errStr: 'Please enter a valid name or identifier',
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERRBUILDINGIDENTIFIERTOOSHORT',
        errStr: 'Please enter a valid name or identifier',
        value: 1,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERRBUILDINGIDENTIFIERTOOLONG',
        errStr: 'Please enter a valid name or identifier',
        value: 300,
      },
    ],
  };
}
